export default "__VITE_ASSET__C7iU7ueT__"